export enum EDocumentoID {
    Cpf = 1, 
    CarteiraTrabalho = 2,
    Passsaporte = 3,
    Rnm = 4,
    Cnh = 5,
    ComprovanteResidenacia = 6,
    CertidaoNascimento = 7,
}

export enum EDocumentoDescricao {
    Cpf = "CPF",
    CarteiraTrabalho = "Carteira de Trabalho",
    Passsaporte = "Passaporte",
    Rnm = "RNM",
    Cnh = "CNH",  
    ComprovanteResidenacia = "Comprovante Residência",  
    CertidaoNascimento = "Certidão de Nascimento",  
}